import React from "react"
import 'react-toastify/dist/ReactToastify.css';
import Header from './Header';
import Footer from './Footer';
import { useState } from "react"

import Nav from './Nav';














export default function ComingSoon(props){
 

    const [isSidebarOpen, setIsSidebarOpen] = useState(true);

    const toggleSidebar = () => {
      setIsSidebarOpen(!isSidebarOpen);
    };
       
  





return (
  <div id="wrapper">
      <Header isSidebarOpen={isSidebarOpen} />
     
      <div id="content-wrapper" class="d-flex flex-column">
        <div id="content">
          
        <Nav  toggleSidebar={toggleSidebar}/>
  

    
    <div class="container-fluid">
    
    <h1>Coming Soon!!!</h1>

    </div>
   

</div>



<Footer />

</div>
    </div>
  
        
      )
}





 